import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DropdownRows from './DropdownRows';
import ColumnButton from './ColumnButton';
import Checkbox from '../common/checkbox/Checkbox';
import checkBoxStyle from './CheckboxOverride.module.scss';
import ActionButton from '../common/actionbutton/ActionButton';

const ColumnSelector = (props) => (
    <div>
        <ColumnButton toggleDropdown={ props.toggleDropdown } styles={ props.styles } />
        { props.dropdownOpen ? (
            <DragDropContext onDragEnd={ props.onDragEnd }>
                <Droppable droppableId="droppable" className="testing">
                    { (provided) => (
                        <div className={ props.styles.wrapper }>
                            <div className={ props.styles.dropdownHeader }>
                                <div
                                    className={
                                        props.styles.toggleUnselectedCheckbox
                                    }
                                >
                                    <Checkbox
                                        styles={ checkBoxStyle }
                                        checked={
                                            props.hidingUnselected
                                        }
                                        onChange={ (checked) => {
                                            props.setHidingUnselected(checked);
                                        } }
                                    />
                                </div>
                                <div className={ props.styles.header }>
                                    Choose and Reorder Columns
                                </div>
                            </div>

                            <div
                                ref={ provided.innerRef }
                                className={ props.styles.columnDropdownList }
                            >
                                <DropdownRows
                                    styles={ props.styles }
                                    columns={ props.columnsToRender }
                                    setColumnVisibility={ props.setColumnVisibility }
                                />

                            </div>
                            <div className={ props.styles.applyChangeButton }>
                                <ActionButton
                                    accent
                                    onClick={ props.submitInfo }
                                >
                                    Apply Changes
                                </ActionButton>
                            </div>
                        </div>
                    ) }
                </Droppable>
            </DragDropContext>
        ) : null }
    </div>
);

ColumnSelector.propTypes = {
    columnsToRender: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string,
            type: PropTypes.string
        })
    ),
    dropdownOpen: PropTypes.bool,
    hidingUnselected: PropTypes.bool,
    onDragEnd: PropTypes.func,
    setColumnVisibility: PropTypes.func,
    setHidingUnselected: PropTypes.func,
    submitInfo: PropTypes.func,
    toggleDropdown: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string).isRequired
};

ColumnSelector.defaultProps = {
    columnsToRender: [],
    dropdownOpen: false,
    hidingUnselected: false,
    onDragEnd: noop,
    setColumnVisibility: noop,
    setHidingUnselected: noop,
    submitInfo: noop,
    toggleDropdown: noop
};

export default ColumnSelector;
